import "lazysizes";
import "@/style/pc/common.scss";
import "./store.scss";

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import Swiper from "swiper";
import "swiper/css/swiper.min.css";

gsap.registerPlugin(ScrollTrigger);

gsap.to(".pc-header", {
  backgroundColor: "#fff",
  height: WindowWidth < 903 ? "70px" : "80px",
  borderBottom: "1px solid #efefef",
  scrollTrigger: {
    trigger: ".store-layer",
    start: "top",
    end: "top+=1",
    scrub: 0.3,
  },
});

gsap.to(".pc-header .logo", {
  width: "144px",
  height: "58px",
  scrollTrigger: {
    trigger: ".store-layer",
    start: "top",
    end: "top+=1",
    scrub: 0.3,
  },
});

gsap.fromTo(".us-phone, nav .color-f, .us-phone .phone-number, .us-phone .phone-desc",
  { color: "#fff" },
  { color: "#1B451D",
  scrollTrigger: {
    trigger: ".store-layer",
    start: "top",
    end: "top+=1",
    scrub: 0.3,
  },
});
gsap.to(".logo-img-white", {
  opacity: 0,
  scrollTrigger: {
    trigger: ".store-layer",
    start: "top",
    end: "top+=1",
    scrub: 0.3,
  },
});


document
  .querySelector(".mobile-menu-btn")
  .addEventListener("click", function () {
    document.querySelector(".mobile-header-nav").classList.add("block");
  });
document
  .querySelector(".mobile-header-nav-close")
  .addEventListener("click", function (e) {
    document.querySelector(".mobile-header-nav").classList.remove("block");
    e.stopPropagation();
    e.preventDefault();
  });

// 移动端下拉菜单交互
document.querySelectorAll('.mobile-nav-parent').forEach(function(parent) {
  parent.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    const dropdown = this.parentElement;
    const submenu = dropdown.querySelector('.mobile-submenu');
    const arrow = this.querySelector('.dropdown-arrow');
    
    // 切换当前菜单
    this.classList.toggle('active');
    submenu.classList.toggle('show');
  });
});

var WindowWidth = 0;
function updateScreenSize() {
  WindowWidth = document.documentElement.clientWidth;
}
updateScreenSize();
window.addEventListener("resize", updateScreenSize);

// 门店类型 Swiper
var storeTypeSwiper = null;
var storeTypeObserver = null;

function initStoreTypeSwiper() {
  if (storeTypeSwiper !== null) {
    storeTypeSwiper.destroy(false);
  }

  const tabs = document.querySelectorAll(".store-type-tab");
  
  storeTypeSwiper = new Swiper(".store-type-swiper", {
    slidesPerView: 1,
    spaceBetween: 0,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    lazy: {
      loadPrevNext: true,
      loadOnTransitionStart: true,
    },
    speed: 500,
    allowTouchMove: false,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    on: {
      slideChange: function () {
        const currentIndex = this.activeIndex;
        tabs.forEach(function (tab, index) {
          if (index === currentIndex) {
            tab.classList.add('active');
          } else {
            tab.classList.remove('active');
          }
        });
      }
    }
  });

  // Tab 点击切换
  tabs.forEach(function (tab) {
    tab.addEventListener("click", function () {
      const index = parseInt(this.getAttribute('data-index'));
      storeTypeSwiper.slideTo(index);
    });
  });

  // 协同控制：hover 状态 + 可视区域状态
  let isHovered = false;
  let isVisible = true;

  function updateAutoplay() {
    if (!storeTypeSwiper || !storeTypeSwiper.autoplay) return;
    if (isHovered || !isVisible) {
      storeTypeSwiper.autoplay.stop();
    } else {
      storeTypeSwiper.autoplay.start();
    }
  }

  const swiperEl = document.querySelector(".store-type-swiper");
  if (swiperEl) {
    swiperEl.addEventListener("mouseenter", function () {
      isHovered = true;
      updateAutoplay();
    });
    swiperEl.addEventListener("mouseleave", function () {
      isHovered = false;
      updateAutoplay();
    });
  }

  // Intersection Observer：组件完全移出可视区域时暂停，进入时恢复
  if (storeTypeObserver) {
    storeTypeObserver.disconnect();
  }
  storeTypeObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        isVisible = entry.isIntersecting;
        updateAutoplay();
      });
    },
    {
      threshold: 0,
    }
  );
  if (swiperEl) {
    storeTypeObserver.observe(swiperEl);
  }
}

// 开业实况轮播
var storeSwiper = null;
var storeSwiperObserver = null;

function initStoreSwiper() {
  if (storeSwiper !== null) {
    storeSwiper.destroy(false);
  }

  // 根据屏幕宽度动态计算 coverflow depth（depth ≈ slide 宽度）
  var slideWidth = 846;
  if (WindowWidth <= 600) {
    slideWidth = Math.min(WindowWidth - 80, 440);
  } else if (WindowWidth <= 800) {
    slideWidth = 400;
  } else if (WindowWidth <= 1000) {
    slideWidth = 480;
  } else if (WindowWidth <= 1200) {
    slideWidth = 640;
  }

  storeSwiper = new Swiper(".store-opening-swiper", {
    effect: 'coverflow',
    centeredSlides: true,
    slidesPerView: "auto",
    loop: true,
    loopedSlides: 5,
    speed: 600,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    coverflowEffect: {
      rotate: 0,
      stretch: 0,
      depth: slideWidth,
      modifier: 1,
      slideShadows: false,
    },
    lazy: {
      loadPrevNext: true,
      loadOnTransitionStart: true,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    on: {
      click: function () {
        var clickedIndex = this.clickedIndex;
        if (typeof clickedIndex === 'undefined') return;
        var clickedSlide = this.slides[clickedIndex];
        if (!clickedSlide) return;
        var targetRealIndex = parseInt(
          clickedSlide.getAttribute('data-swiper-slide-index'),
          10
        );
        if (isNaN(targetRealIndex) || targetRealIndex === this.realIndex) return;

        var loopedSlides = this.params.loopedSlides || 0;
        var targetIndex = targetRealIndex + loopedSlides;
        this.slideTo(targetIndex, this.params.speed);
      }
    }
  });

  // 协同控制：hover 状态 + 可视区域状态
  let isHovered = false;
  let isVisible = true;

  function updateAutoplay() {
    if (!storeSwiper || !storeSwiper.autoplay) return;
    if (isHovered || !isVisible) {
      storeSwiper.autoplay.stop();
    } else {
      storeSwiper.autoplay.start();
    }
  }

  const swiperEl = document.querySelector(".store-opening-swiper");
  if (swiperEl) {
    swiperEl.addEventListener("mouseenter", function () {
      isHovered = true;
      updateAutoplay();
    });
    swiperEl.addEventListener("mouseleave", function () {
      isHovered = false;
      updateAutoplay();
    });
  }

  // Intersection Observer：组件完全移出可视区域时暂停，进入时恢复
  if (storeSwiperObserver) {
    storeSwiperObserver.disconnect();
  }
  storeSwiperObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        isVisible = entry.isIntersecting;
        updateAutoplay();
      });
    },
    {
      threshold: 0,
    }
  );
  if (swiperEl) {
    storeSwiperObserver.observe(swiperEl);
  }
}

// 初始化轮播
document.addEventListener("DOMContentLoaded", function () {
  initStoreTypeSwiper();
  initStoreSwiper();

  // 窗口 resize 时重新初始化开业实况轮播（适配 depth 变化）
  var resizeTimer = null;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      initStoreSwiper();
    }, 300);
  });
});
